// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sub-menu__title[data-v-66f37391] {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.5rem;
      text-transform: uppercase;
}
.sub-menu__title[data-v-66f37391]:hover {
      --tw-text-opacity: 1;
      color: rgb(200 143 0 / var(--tw-text-opacity));
}
@media (min-width: 996px) {
.sub-menu__title[data-v-66f37391] {
            padding-left: 1rem;
            padding-right: 1rem;
            padding-top: 2rem;
            padding-bottom: 2rem;
}
}
.menu__item:hover .sub-menu__title[data-v-66f37391] {
      --tw-text-opacity: 1;
      color: rgb(200 143 0 / var(--tw-text-opacity));
}
.sub-menu--display .sub-menu__title[data-v-66f37391] {
      text-decoration-line: underline;
}
@media (min-width: 996px) {
.sub-menu--display .sub-menu__title[data-v-66f37391] {
            text-decoration-line: none;
}
}
.menu__item:hover .sub-menu__title svg[data-v-66f37391] {
      fill: #C88F00;
}
.sub-menu__items[data-v-66f37391] {
      top: 5.5rem;
      display: none;
      width: 100%;
      min-width: 18rem;
      --tw-scale-x: 0;
      --tw-scale-y: 0;
      transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
      flex-direction: column;
      gap: 1rem;
      --tw-border-opacity: 1;
      border-color: rgb(229 231 235 / var(--tw-border-opacity));
      padding-top: 1rem;
      padding-bottom: 1rem;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
      text-transform: none;
      opacity: 0;
      transition-property: opacity;
      transition-duration: 300ms;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      font-family: Roboto;
      line-height: 1.35;
      font-size: 1.125rem;
      font-weight: 700;
}
@media (min-width: 640px) {
.sub-menu__items[data-v-66f37391] {
            padding-right: 3rem;
}
}
@media (min-width: 996px) {
.sub-menu__items[data-v-66f37391] {
            position: absolute;
            display: flex;
            width: -moz-max-content;
            width: max-content;
            gap: 0;
            border-radius: 8px;
            border-width: 1px;
            --tw-bg-opacity: 1;
            background-color: rgb(255 255 255 / var(--tw-bg-opacity));
            padding-top: 0;
            padding-bottom: 0;
            padding-left: 0;
            padding-right: 0;
            --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
            --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
            box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
            transition-delay: 200ms;
            font-family: Roboto;
            line-height: 1.35;
            font-size: 1.125rem;
            font-weight: 400;
}
}
.sub-menu--display .sub-menu__items[data-v-66f37391] {
      display: flex;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
      opacity: 1;
}
@media (min-width: 996px) {
.sub-menu--display .sub-menu__items[data-v-66f37391] {
            display: none;
}
.menu__item:hover .sub-menu__items[data-v-66f37391] {
            display: block;
            --tw-scale-x: 1;
            --tw-scale-y: 1;
            transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
            opacity: 1;
}
}
.sub-menu__item[data-v-66f37391] {
      display: flex;
      justify-content: space-between;
      gap: 1rem;
}
@media (min-width: 996px) {
.sub-menu__item[data-v-66f37391] {
            padding-left: 1.5rem;
            padding-right: 1.5rem;
            padding-top: 1rem;
            padding-bottom: 1rem;
}
.sub-menu__item[data-v-66f37391]:hover {
            --tw-bg-opacity: 1;
            background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
}
.sub-menu__item[data-v-66f37391]:first-of-type {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
}
.sub-menu__item[data-v-66f37391]:last-of-type {
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
}
.sub-menu__item[data-v-66f37391]:not(:hover) {
      transition: padding-left 0.5s ease;
}
.sub-menu__item[data-v-66f37391]:hover {
      --tw-text-opacity: 1;
      color: rgb(200 143 0 / var(--tw-text-opacity));
}
@media (min-width: 996px) {
.sub-menu__item[data-v-66f37391]:hover {
            --tw-bg-opacity: 1;
            background-color: rgb(250 237 205 / var(--tw-bg-opacity));
            padding-left: 3rem;
}
}
.sub-menu__item[data-v-66f37391]:hover:before {
      position: absolute;
      left: 1rem;
}
@media (min-width: 996px) {
.sub-menu__item[data-v-66f37391]:hover:before {
            --tw-content: '\\2192';
            content: var(--tw-content);
}
}
.sub-menu__link[data-v-66f37391] {
      display: flex;
      width: 100%;
      justify-content: space-between;
}
@media (min-width: 996px) {
.sub-menu__link[data-v-66f37391] {
            width: -moz-fit-content;
            width: fit-content;
}
.sub-menu__icon[data-v-66f37391] {
            display: none;
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/menus/SubMenu.vue"],"names":[],"mappings":";AAkEA;MAAA,aAAA;MAAA,mBAAA;MAAA,8BAAA;MAAA,WAAA;MAAA,yBAAA;AAAA;AAAA;MAAA,oBAAA;MAAA,8CAAA;AAAA;AAAA;AAAA;YAAA,kBAAA;YAAA,mBAAA;YAAA,iBAAA;YAAA,oBAAA;AAAA;AAAA;AAGA;MAAA,oBAAA;MAAA,8CAAA;AAAA;AAGA;MAAA,+BAAA;AAAA;AAAA;AAAA;YAAA,0BAAA;AAAA;AAAA;AAKA;MAAA,aAAA;AAAA;AAKA;MAAA,WAAA;MAAA,aAAA;MAAA,WAAA;MAAA,gBAAA;MAAA,eAAA;MAAA,eAAA;MAAA,+LAAA;MAAA,sBAAA;MAAA,SAAA;MAAA,sBAAA;MAAA,yDAAA;MAAA,iBAAA;MAAA,oBAAA;MAAA,oBAAA;MAAA,qBAAA;MAAA,oBAAA;MAAA,UAAA;MAAA,4BAAA;MAAA,0BAAA;MAAA,wDAAA;MAAA,mBAAA;MAAA,iBAAA;MAAA,mBAAA;MAAA,gBAAA;AAAA;AAAA;AAAA;YAAA,mBAAA;AAAA;AAAA;AAAA;AAAA;YAAA,kBAAA;YAAA,aAAA;YAAA,uBAAA;YAAA,kBAAA;YAAA,MAAA;YAAA,kBAAA;YAAA,iBAAA;YAAA,kBAAA;YAAA,yDAAA;YAAA,cAAA;YAAA,iBAAA;YAAA,eAAA;YAAA,gBAAA;YAAA,gDAAA;YAAA,6DAAA;YAAA,uGAAA;YAAA,uBAAA;YAAA,mBAAA;YAAA,iBAAA;YAAA,mBAAA;YAAA,gBAAA;AAAA;AAAA;AAGA;MAAA,aAAA;MAAA,eAAA;MAAA,eAAA;MAAA,+LAAA;MAAA,UAAA;AAAA;AAAA;AAAA;YAAA,aAAA;AAAA;AAGA;YAAA,cAAA;YAAA,eAAA;YAAA,eAAA;YAAA,+LAAA;YAAA,UAAA;AAAA;AAHA;AAOA;MAAA,aAAA;MAAA,8BAAA;MAAA,SAAA;AAAA;AAAA;AAAA;YAAA,oBAAA;YAAA,qBAAA;YAAA,iBAAA;YAAA,oBAAA;AAAA;AAAA;YAAA,kBAAA;YAAA,yDAAA;AAAA;AAAA;AAGA;MAAA,2BAAA;MAAA,4BAAA;AAAA;AAGA;MAAA,+BAAA;MAAA,8BAAA;AAAA;AAEA;MACA,kCAAA;AACA;AAEA;MAAA,oBAAA;MAAA,8CAAA;AAAA;AAAA;AAAA;YAAA,kBAAA;YAAA,yDAAA;YAAA,kBAAA;AAAA;AAAA;AAGA;MAAA,kBAAA;MAAA,UAAA;AAAA;AAAA;AAAA;YAAA,qBAAA;YAAA,0BAAA;AAAA;AAAA;AAKA;MAAA,aAAA;MAAA,WAAA;MAAA,8BAAA;AAAA;AAAA;AAAA;YAAA,uBAAA;YAAA,kBAAA;AAAA;AAGA;YAAA,aAAA;AAAA;AAHA","sourcesContent":["<template>\n  <div class=\"sub-menu\" :class=\"{ 'sub-menu--display': display }\" v-hover=\"{ cb: hover, args: [BRAND_PRIMARY_DARKEST] }\">\n    <div class=\"sub-menu__title\" @click=\"toggleSubmenu\">\n      <p>{{ name }}</p>\n      <Icon name=\"down-arrow\" :size=\"10\" :color=\"iconColor\" />\n    </div>\n    <ul class=\"sub-menu__items\">\n      <SubMenuItem v-for=\"(value, key) in elements[0]\" :key=\"key\" :href=\"value\" icon=\"right-arrow\">{{ key }}</SubMenuItem>\n    </ul>\n  </div>\n</template>\n\n<script>\nimport { ref } from '@vue/composition-api';\nimport { Link } from '@inertiajs/inertia-vue';\nimport Icon from '@/lego/components/icons/Icon.vue';\nimport SubMenuItem from '@/lego/components/menus/SubMenuItem.vue';\nimport { onMinWidth } from '@/lego/utils/window/screen';\n\nconst BRAND_PRIMARY_DARKEST = '#C88F00';\n\nexport default {\n  components: {\n    Link,\n    Icon,\n    SubMenuItem,\n  },\n  props: {\n    name: {\n      type: String,\n      required: true,\n    },\n    elements: {\n      type: Array,\n      required: true,\n    },\n  },\n  setup() {\n    var display = ref(false);\n    var iconColor = ref('black');\n\n    function toggleSubmenu() {\n      display.value = !display.value;\n    }\n    function hover(el, color) {\n      iconColor.value = color ?? 'black';\n    }\n\n    onMinWidth(996, function() {\n      display.value = false;\n    });\n\n    return {\n      display,\n      iconColor,\n      toggleSubmenu,\n      hover,\n      BRAND_PRIMARY_DARKEST,\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.sub-menu {\n  &__title {\n    @apply uppercase flex items-center justify-between gap-nano hover:text-brand-primary-darkest lg:px-xxxs lg:py-xs;\n\n    .menu__item:hover & {\n      @apply text-brand-primary-darkest;\n    }\n    .sub-menu--display & {\n      @apply underline lg:no-underline;\n    }\n\n    svg {\n      .menu__item:hover & {\n        @apply fill-brand-primary-darkest;\n      }\n    }\n  }\n  &__items {\n    @apply min-w-[18rem] hidden lg:flex opacity-0 scale-0 style-body-bold lg:style-body lg:delay-200 ease-in-out normal-case lg:bg-neutral-white lg:rounded-sm lg:border-hairline border-neutral-light py-xxxs lg:py-0 px-xxs sm:pr-md lg:px-0 flex-col gap-xxxs lg:gap-0 lg:absolute lg:shadow-2xl w-full lg:w-max top-[5.5rem] transition-opacity duration-300;\n\n    .sub-menu--display & {\n      @apply flex lg:hidden opacity-100 scale-100;\n    }\n    .menu__item:hover & {\n      @apply lg:block lg:opacity-100 lg:scale-100;\n    }\n  }\n  &__item {\n    @apply flex justify-between gap-xxxs lg:hover:bg-neutral-lightest lg:px-xxs lg:py-xxxs;\n\n    &:first-of-type {\n      @apply rounded-t-s;\n    }\n    &:last-of-type {\n      @apply rounded-b-s;\n    }\n    &:not(:hover) {\n      transition: padding-left 0.5s ease;\n    }\n    &:hover {\n      @apply text-brand-primary-darkest lg:bg-brand-primary-lightest lg:pl-md;\n\n      &:before {\n        @apply absolute left-xxxs lg:content-['\\2192'];\n      }\n    }\n  }\n  &__link {\n    @apply flex justify-between w-full lg:w-fit;\n  }\n  &__icon {\n    @apply lg:hidden;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
